module.exports = __webpack_public_path__ + "media/assets/faria_products/CT-AR-f391af27feb40ebcaef4f48cfa7b42e165f976f856a1b9c149545d32d5fde60a.png";